import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { createClosure } from '@/lib/venue/closureApi'
import type { VenueClosureCreateInput, VenueClosureCreatedView } from '@/lib/venue/closureTypes'

import { venueClosuresQueryKey } from './useVenueClosures'

/**
 * 휴무·차단·레슨 등록 (#604).
 * 응답(`list`)을 목록 쿼리 캐시에 **직접 반영**한다 — 재조회하지 않는다(Reader 복제 지연 회피,
 * 코트 등록(#597)·운영시간 저장(#600)과 같은 관행).
 */
export function useCreateVenueClosure(venueId: string) {
  const queryClient = useQueryClient()

  return useMutation<VenueClosureCreatedView, ApiError, VenueClosureCreateInput>({
    mutationFn: (input) => createClosure(venueId, input),
    onSuccess: (data) => {
      queryClient.setQueryData(venueClosuresQueryKey(venueId), data.list)
    },
  })
}
